module.exports = __webpack_public_path__ + "static/media/UHS_Logo_EnrollmentPortal.dbb47ad9.png";